// extracted by mini-css-extract-plugin
module.exports = {"pintxo-tab":"Tab_pintxo-tab__H4osv","pintxo-tab__content":"Tab_pintxo-tab__content__yf2lq","pintxo-tab__indicator":"Tab_pintxo-tab__indicator__nWEFf"};